import { h } from "preact";
import { useContext } from "preact/hooks";
import { SimpleReferralWidgetContext } from "../index";

const HowItWorks = props => {
  const simpleReferralWidgetContext = useContext(SimpleReferralWidgetContext);

  const calculateMaxDiscount = () => {
    let finalPrice = parseFloat(window.Shopify.checkout.total_price, 10);
    let campaignMaxDiscount =
      simpleReferralWidgetContext.currentCampaign.maxDiscountValue;
    if (finalPrice < campaignMaxDiscount) {
      return finalPrice;
    } else {
      return campaignMaxDiscount;
    }
  };

  const wordReplacer = sourceText => {
    const offerViewTitleWordMap = [
      {
        placeholder: "<reward>",
        value: `${simpleReferralWidgetContext.currentCampaign.rewardConfig
          .rewardValue * -1}${
          simpleReferralWidgetContext.currentCampaign.rewardConfig
            .rewardDimension === "percentage"
            ? "%"
            : ` ${window.Shopify.currency.active}`
        }`
      },
      {
        placeholder: "<maximum_reward>",
        value: `${calculateMaxDiscount()} ${window.Shopify.currency.active}`
      }
    ];
    let text = sourceText;
    offerViewTitleWordMap.map(item => {
      text = text.replace(item.placeholder, item.value);
    });
    return text;
  };

  return (
    <div
      id="coca-referral-how-works-wrapper"
      className=" flex flex-col items-center m-4 bg-gray-100 p-4 rounded-md border border-gray-200"
    >
      <div
        id="coca-referral-how-works-title"
        className=" text-center font-bold text-base"
      >
        {simpleReferralWidgetContext.currentLanguage &&
        simpleReferralWidgetContext.currentLanguage.simple_how_it_work_title
          ? simpleReferralWidgetContext.currentLanguage.simple_how_it_work_title
          : "How it works"}
      </div>
      <div
        id="coca-referral-how-works-items-wrapper"
        className=" max-w-sm mt-3 grow shrink-0  "
      >
        <div
          id="coca-referral-how-works-item-1"
          className="coca-referral-how-works-item mb-3 flex items-center"
        >
          <div className="coca-referral-how-works-item-icon text-lg font-bold mr-3 p-2 flex items-center justify-center text-center rounded-md bg-white text-gray-700">
            &#8594;
          </div>
          <div className="coca-referral-how-works-item-text">
            {props.rewardType === "cashback" ? (
              <p>
                {simpleReferralWidgetContext.currentLanguage &&
                simpleReferralWidgetContext.currentLanguage
                  .simple_how_it_work_line1_cashback
                  ? simpleReferralWidgetContext.currentLanguage
                      .simple_how_it_work_line1_cashback
                  : "Click below to get a discount coupon to share with friends"}
              </p>
            ) : (
              <p>
                {simpleReferralWidgetContext.currentLanguage &&
                simpleReferralWidgetContext.currentLanguage
                  .simple_how_it_work_line1_coupon
                  ? simpleReferralWidgetContext.currentLanguage
                      .simple_how_it_work_line1_coupon
                  : "Click below to get a discount coupon to share with friends"}
              </p>
            )}
          </div>
        </div>
        <div
          id="coca-referral-how-works-item-2"
          className="coca-referral-how-works-item mb-3 flex items-center"
        >
          <div className="coca-referral-how-works-item-icon text-lg font-bold mr-3 p-2 flex items-center justify-center text-center rounded-md bg-white text-gray-700">
            &#8594;
          </div>
          <div className="coca-referral-how-works-item-text">
            {props.rewardType === "cashback" ? (
              <p>
                {simpleReferralWidgetContext.currentLanguage &&
                simpleReferralWidgetContext.currentLanguage
                  .simple_how_it_work_line2_cashback
                  ? wordReplacer(
                      simpleReferralWidgetContext.currentLanguage
                        .simple_how_it_work_line2_cashback
                    )
                  : wordReplacer(
                      "when a friend creates an order using your coupon, you get a <reward> cashback."
                    )}
              </p>
            ) : (
              <p>
                {simpleReferralWidgetContext.currentLanguage &&
                simpleReferralWidgetContext.currentLanguage
                  .simple_how_it_work_line2_coupon
                  ? wordReplacer(
                      simpleReferralWidgetContext.currentLanguage
                        .simple_how_it_work_line2_coupon
                    )
                  : wordReplacer(
                      "when a friend creates an order using your coupon, you get a <r> coupon."
                    )}
              </p>
            )}
          </div>
        </div>
        <div
          id="coca-referral-how-works-item-3"
          className="coca-referral-how-works-item mb-3 flex items-center"
        >
          <div className="coca-referral-how-works-item-icon text-lg font-bold mr-3 p-2 flex items-center justify-center text-center rounded-md bg-white text-gray-700">
            &#8594;
          </div>
          <div className="coca-referral-how-works-item-text">
            {props.rewardType === "cashback" ? (
              <p>
                {simpleReferralWidgetContext.currentLanguage &&
                simpleReferralWidgetContext.currentLanguage
                  .simple_how_it_work_line3_cashback
                  ? wordReplacer(
                      simpleReferralWidgetContext.currentLanguage
                        .simple_how_it_work_line3_cashback
                    )
                  : wordReplacer(
                      "Cashback is limited to upto <maximum_reward> on this order"
                    )}
              </p>
            ) : (
              <p>
                {simpleReferralWidgetContext.currentLanguage &&
                simpleReferralWidgetContext.currentLanguage
                  .simple_how_it_work_line3_coupon
                  ? simpleReferralWidgetContext.currentLanguage
                      .simple_how_it_work_line3_coupon
                  : "The more you refer, more discount coupons you get"}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
